module.exports = __webpack_public_path__ + "img/sv4.c307ab9.png";